/* Load each optional component once, including sections added later in the editor. */
(() => {
  'use strict';
  if (window.DV6Bootstrap) return;
  let assets = {};
  try { assets = JSON.parse(document.getElementById('Dv6Assets')?.textContent || '{}'); } catch (_) { return; }
  const loaded = new Map();
  const rules = [
    ['header', 'dv2-masthead'], ['search', 'dv6-search[data-enabled="true"][data-platform-enabled="true"]'],
    ['collections', 'dv3-explorer,[data-dv4-catalog]'], ['campaigns', 'dv4-campaigns'],
    ['editor', '[data-dv5-features],.dv5-questions,[data-dv3-explore-link]'],
    ['experience', 'dv6-guide,dv6-product-nav,[data-dv6-outline="true"],[data-dv6-accordion]']
  ];
  function load(key) {
    if (!assets[key] || loaded.has(key)) return;
    const script = document.createElement('script'); script.src = assets[key]; script.async = false;
    script.dataset.dv6Module = key; loaded.set(key, script);
    script.addEventListener('error', () => { loaded.delete(key); script.remove(); }, { once: true });
    document.head.appendChild(script);
  }
  function init(scope = document) {
    rules.forEach(([key, selector]) => {
      if (scope.matches?.(selector) || scope.querySelector?.(selector)) load(key);
    });
  }
  window.DV6Bootstrap = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
